// extracted by mini-css-extract-plugin
export default {"UploadFlow":"UploadFlow_UploadFlow__vUauO","UploadFlowPaper":"UploadFlow_UploadFlowPaper__lZODA","dialogIcon":"UploadFlow_dialogIcon__377iV","header":"UploadFlow_header__irCfv"};